import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { isEmpty } from 'lodash';
import {
  fetchAllBrandAction,
  fetchCategoryAction1,
  fetchCategoryAction2,
  filterSortData,
  getSeasonsAction,
  getSuppliers,
  getTestingList,
  getUserSuppliers,
} from './store/Testing.action';
import { Page_Size as PageSize } from '../../../../Components/helper';
import NavBar from './NavBar';
import List from './List';
import { mappedArray } from './Constant';
import { getSupplierBrands } from '../CostingTsx/store/Costing.action';
import { fetchColorListLibrary } from '../../../Library/ColorLibary/store/ColorLibrary.action';
import { fetchAllBoms } from '../../../Library/BomType/Store/BomType.action';
import { fetchTier1SupplierListAction, fetchTier2AboveSupplierListAction } from '../../../Supplier/store/Supplier.action';
import { fetchTestTypeMaster, getSubBrandAccess } from '../../../SystemMasters/Store/SystemMasters.action';

function Testing() {
  const dispatch = useDispatch();
  const reducers = useSelector((redState) => redState);
  const {
    TestingTodoListData: {
      testingListData,
      testingListTotalCount,
      testingSelectedIds,
      testingFilterValues: {
        searchText,
        selectedSeason,
        selectedBrand,
        selectedProductSupplier,
        selectedMonth,
        selectedYear,
        selectedCategory1,
        selectedCategory2,
        selectedCategory3,
        selectedCategory4,
        selectedTestingType,
        selectedBOM,
        selectedComponentSupplier,
        selectedColourRef,
        selectedStatus,
        selectedExpiry,
        selectedExclude,
        pageIndex,
        selectedStartDate,
        selectedEndDate,
        sortPropertyName,
        sortOrder,
      },
    },
    UserDetails: {
      userInfo: { userId },
      userRole,
      isSupplierLoggedIn,
      isCompanyUserLoggedIn,
    },
    SystemMastersDetails: { subBrandAccess },
  } = reducers;

  const [state, setState] = useState({
    testingTodoList: [],
    totalRecords: null,
    searchLoaded: false,
    selectedCount: 0,
    isLoading: false,
    hasMore: false,
    loading: true,
  });
  const [selectedColumn, setSelectedColumn] = useState([...mappedArray]);

  useEffect(() => {
    const callFn = async () => {
      try {
        Promise.all([
          dispatch(fetchTestTypeMaster()),
          dispatch(fetchAllBoms()),
          dispatch(
            fetchColorListLibrary({
              loggedInUserId: userId,
            }),
          ),
          dispatch(
            fetchCategoryAction1({
              categoryType: 1,
              loggedInUserId: userId,
            }),
          ),
          dispatch(
            fetchCategoryAction2({
              categoryType: 2,
              loggedInUserId: userId,
            }),
          ),
          dispatch(getSeasonsAction({ loggedInUserId: userId })),
          dispatch(fetchTier1SupplierListAction()),
          dispatch(fetchTier2AboveSupplierListAction()),
        ]);
      } catch (error) {
        console.log('Error while calling initial Apis for filter', error);
      }
      if (isSupplierLoggedIn) {
        dispatch(getSupplierBrands(userId));
      } else {
        dispatch(
          fetchAllBrandAction({
            loggedInUserId: userId,
          }),
        );
        if (isCompanyUserLoggedIn) {
          dispatch(getUserSuppliers());
        } else {
          dispatch(
            getSuppliers({
              loggedInUserId: userId,
            }),
          );
        }
      }
    };
    if (!isEmpty(userId)) callFn();
  }, [dispatch, userId]); // eslint-disable-line

  useEffect(() => {
    const callFn = async () => {
      let filterd = {};
      const obj = JSON.parse(localStorage.getItem('testingTodoListFilter'));
      if (obj) {
        filterd = {
          seasons: obj.selectedSeason,
          brand: obj.selectedBrand,
          category1: obj.selectedCategory1,
          category2: obj.selectedCategory2,
          category3: obj.selectedCategory3,
          category4: obj.selectedCategory4,
          status: obj.selectedStatus,
          month: obj.selectedMonth,
          year: obj.selectedYear,
          BOMCompoent: obj.selectedBOM,
          colourRef: obj.selectedColourRef,
          componentSupplier: obj.selectedComponentSupplier,
          exclude: obj.selectedExclude,
          expiry: obj.selectedExpiry,
          supplier: obj.selectedProductSupplier,
          testingType: obj.selectedTestingType,
          startDate: obj.selectedStartDate,
          endDate: obj.selectedEndDate,
          licensorId: obj.selectedLicensor,
          licenseId: obj.selectedLicense,
          likenessId: obj.selectedLikeness,
        };
        obj.pageIndex = 1;
        dispatch(filterSortData(obj));
      }
      const params = {
        pageSize: PageSize,
        pageIndex: 1,
        type: 'testing',
        ...filterd,
      };
      setState((prevState) => ({ ...prevState, isLoading: true }));
      const res = await dispatch(getTestingList(params));
      if (res) {
        setState((prevState) => ({
          ...prevState,
          hasMore: true,
          isLoading: false,
        }));
      }
    };
    callFn();
  }, [dispatch]);

  useEffect(() => {
    if (testingListTotalCount > testingListData?.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [testingListData?.length, testingListTotalCount]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (state.searchLoaded) {
        const params = {
          searchText,
          pageIndex: 1,
          pageSize: PageSize,
          seasons: selectedSeason,
          year: selectedYear,
          month: selectedMonth,
          brand: selectedBrand,
          status: selectedStatus,
          category1: selectedCategory1,
          category2: selectedCategory2,
          category3: selectedCategory3,
          category4: selectedCategory4,
          BOMCompoent: selectedBOM,
          colourRef: selectedColourRef,
          componentSupplier: selectedComponentSupplier,
          exclude: selectedExclude,
          expiry: selectedExpiry,
          supplier: selectedProductSupplier,
          testingType: selectedTestingType,
          startDate: selectedStartDate,
          endDate: selectedEndDate,
          type: 'testing',
        };

        dispatch(getTestingList(params));
        setState((searchEndState) => ({
          ...searchEndState,
          isLoading: false,
          searchLoaded: false,
        }));
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, dispatch]);

  useEffect(() => {
    const arr = localStorage.getItem('todo_test_selected_options') ? JSON.parse(localStorage.getItem('todo_test_selected_options')) : [...selectedColumn];
    setSelectedColumn([...arr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage]);

  useEffect(() => {
    const fetchSubBrandAccess = async () => {
      await dispatch(getSubBrandAccess());
    };
    fetchSubBrandAccess();
  }, []);

  const handlePageNextInScroll = async () => {
    let index = pageIndex;
    index += 1;
    const params = {
      brand: selectedBrand,
      productSupplier: selectedProductSupplier,
      seasons: selectedSeason,
      month: selectedMonth,
      year: selectedYear,
      category1: selectedCategory1,
      category2: selectedCategory2,
      category3: selectedCategory3,
      category4: selectedCategory4,
      testingType: selectedTestingType,
      BOM: selectedBOM,
      componentSupplier: selectedComponentSupplier,
      colourRef: selectedColourRef,
      status: selectedStatus,
      expiry: selectedExpiry,
      exclude: selectedExclude,
      type: 'testing',
      searchText,
      pageIndex: index,
      pageSize: PageSize,
      totalRecords: testingListTotalCount,
      isScrolled: true,
      startDate: selectedStartDate,
      endDate: selectedEndDate,
      sortOrder,
      sortPropertyName,
    };

    const obj = {
      pageIndex: index,
      pageSize: PageSize,
    };
    setState((prevState) => ({ ...prevState, isLoading: true }));
    await dispatch(filterSortData(obj));
    await dispatch(getTestingList(params));
    setState((prevState) => ({ ...prevState, isLoading: false }));
  };

  const getCount = (selectedCnt) => {
    setState((prevState) => ({
      ...prevState,
      selectedCount: selectedCnt.length,
    }));
  };

  const handleSearch = (e) => {
    const targetValue = e.target.value;
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      searchLoaded: true,
    }));
    const obj = {
      searchText: targetValue,
    };
    dispatch(filterSortData(obj));
  };

  useEffect(() => {
    return () => {
      const obj = {
        searchText: '',
      };
      dispatch(filterSortData(obj));
    };
  }, [dispatch]);

  return (
    <>
      <div>
        <NavBar
          searchText={searchText}
          totalCount={testingListTotalCount}
          testingSelectedIds={testingSelectedIds}
          selectedColumn={selectedColumn}
          setSelectedColumn={setSelectedColumn}
          handleSearch={handleSearch}
          subBrandAccess={subBrandAccess}
        />
      </div>
      <div className="scroll-container">
        <span className="top" />
        <span className="left" />
        <span className="right" />
        <div className="all-scroll">
          <div
            id="scrollableDiv"
            style={{
              height: '100%',
              overflow: 'scroll',
            }}
          >
            <InfiniteScroll
              dataLength={testingListData?.length || 0}
              hasMore={state?.hasMore}
              next={() => handlePageNextInScroll()}
              scrollableTarget="scrollableDiv"
              className="fixed-col-container"
            >
              <List
                loading={state.isLoading}
                getSelectedCount={getCount}
                selectedColumns={selectedColumn}
                userId={userId}
                userRole={userRole}
                subBrandAccess={subBrandAccess}
              />
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </>
  );
}

export default Testing;
